import { Stack, Typography } from '@mui/material';
import { CreateAssortmentMenu } from '@retail/monitoring-assortment/components';
import { mgPrisRoutes } from '@retail/mgpris/config';
import { useDisclosure } from '@shared/hooks';
import { useAssortmentTFunction } from '@retail/monitoring-assortment/i18n';
import { Navigate } from 'react-router';
import { MonitoringAssortmentsProps } from './withMonitoringAssortments';
import { CreateMonitoringAssortment } from './CreateMonitoringAssortment';

export function NoMonitoringAssortmentsContainer({
  monitoringAssortments,
}: MonitoringAssortmentsProps) {
  const t = useAssortmentTFunction();

  const { isOpen: isImportModalOpen, onToggle: toggleImportModal } = useDisclosure(false);
  const { isOpen: isCreateManuallyModalOpen, onToggle: toggleCreateManuallyModal } =
    useDisclosure(false);
  if (monitoringAssortments.length) {
    return <Navigate to={mgPrisRoutes.marketInsight.getFullLinkPath()} />;
  }

  return (
    <Stack gap={2} width="500px" px={5} py={5} alignItems="center" alignSelf="center">
      <Typography component="h1" variant="h4">
        {t('assortment.infoCards.welcome')}
      </Typography>
      <Typography variant="body1" fontSize="18px">
        {t('assortment.infoCards.welcomeDesc')}
      </Typography>

      <div>
        <CreateAssortmentMenu
          openImportModal={toggleImportModal}
          openCreateManuallyModal={toggleCreateManuallyModal}
        />
      </div>

      <CreateMonitoringAssortment
        openImportModal={isImportModalOpen}
        openCreateManuallyModal={isCreateManuallyModalOpen}
        toggleImportModal={toggleImportModal}
        toggleCreateManuallyModal={toggleCreateManuallyModal}
      />
    </Stack>
  );
}
